import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import SVG from 'react-inlinesvg'
import { get } from 'lodash'
import Image from 'components/atoms/Image'
import InfoCard from 'components/molecules/InfoCard/InfoCard'
import Typography from 'components/atoms/Typography/Typography'
import CustomButton from 'components/atoms/CustomButton/CustomButton'
import CustomModal from 'components/molecules/CustomModal/CustomModal'
import { getRemoteVideo, isHexLight, userCheckMobileScreen } from 'helpers/tools'
import PlayIcon from 'assets/img/icone-play.svg'

// Style
import './MediaFull.scss'

function MediaFull({ data }) {
  const isMobile = userCheckMobileScreen()
  const [openImage, setOpenImage] = useState(false)
  const [videoUrl, setVideoUrl] = useState('')
  const card = get(data, 'card.entity')
  const isRemoteVideo = get(data, 'media.entity.entityBundle') === 'remote_video'
  const remoteVideo = isRemoteVideo && getRemoteVideo(get(data, 'media.entity.fieldMediaOembedVideo'))
  const bgColour = get(data, 'backgroundColor.color', '')

  let mediaFullImage = ''
  if (isRemoteVideo) {
    mediaFullImage = remoteVideo.thumb
  } else if (isMobile) {
    mediaFullImage = get(data, 'media.entity.images.large.url')
  } else {
    mediaFullImage = get(data, 'media.entity.images.wide.url')
  }

  const hasCard = !!(
    get(card, 'theme.entity.classes') || 
    get(card, 'button.entity.link.url.path') ||
    get(card, 'sectionTitle') ||
    get(card, 'title') ||
    get(card, 'subtitle')
  )

  const hasDescriptionMedia = !!(
    get(data, 'title') || 
    get(data, 'description.value') || 
    get(data, 'button.entity.link.title')
  )

  return (
    <Container className="media-full" fluid style={{ backgroundColor: get(data, 'secBackgroundColor.color') }}>
      <CustomModal
        className="media-full__modal"
        closeModal={() => {
          setOpenImage(!openImage)
          setVideoUrl('')
        }}
        open={openImage}
        size={userCheckMobileScreen() ? 'sm' : 'lg'}
      >
        <div className="d-flex align-items-center justify-content-center pb-md-5">
          <iframe
            src={videoUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </CustomModal>

      <Container>
        <Row className="media-full__banner d-flex">
          <Col>
            {isRemoteVideo && (
              <button
                className="d-flex justify-content-center media-full__button-play"
                onClick={() => {
                  setOpenImage(!openImage)
                  setVideoUrl(remoteVideo.url)
                }}
              >
                <SVG className="media-full__banner-icon" src={PlayIcon} />
              </button>
            )}
            <Image
              alt={get(data, 'media.entity.images.alt')}
              className="media-full__banner-image"
              src={mediaFullImage}
            />
          </Col>
        </Row>
      </Container>
        <div style={{ backgroundColor: bgColour }} className={(hasCard || hasDescriptionMedia) ? '' : 'media-full__content  pb-md-5'}>
        {(hasCard || hasDescriptionMedia) && (
          <Container className="d-flex justify-content-center">
            <Row className="media-full__content pb-5">
              <Col lg={{ span: 4, offset: 2 }} xl={{ span: 4, offset: 1 }}>
                {hasCard && (
                  <InfoCard
                    theme={`${get(card, 'theme.entity.classes')} card-info--media height-content`}
                    url={get(card, 'button.entity.link.url.path')}
                    sectionTitle={{ title: get(card, 'sectionTitle') }}
                    title={get(card, 'title')}
                    subtitle={get(card, 'subtitle')}
                    titleMaxLine={7}
                  />
                )}
              </Col>
              <Col lg={5} xl={{ span: 6, offset: 1 }} className="mt-4">
                {hasDescriptionMedia && (
                  <>
                    {get(data, 'title') && (
                      <Typography color={isHexLight(bgColour) ? 'black' : 'white'} cssClass="mb-3 font-weight-bold">
                        {get(data, 'title')}
                      </Typography>
                    )}
                    {get(data, 'description.value') && (
                      <Typography color={isHexLight(bgColour) ? 'black' : 'white'} variant="span">
                        {ReactHtmlParser(get(data, 'description.value'))}
                      </Typography>
                    )}
                    {get(data, 'button.entity.link.title') && (
                      <CustomButton
                        className="mt-4 media-full__link"
                        text={get(data, 'button.entity.link.title')}
                        iconAlign="right"
                        color={get(card, 'theme.entity.classes')}
                        href={get(data, 'button.entity.link.url.path')}
                      />
                    )}
                  </>
                )}
              </Col>
            </Row>
          </Container>
        )}
        </div>
    </Container>
  )
}

export default MediaFull
